import React, { useState } from "react";
import axios from "axios";

const LogsUsuarioMiIsep = ({ escuela }) => {

  const [dni, setDni] = useState("");
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const traducirAccion = (accion) => {

    const acciones = {
      viewed: "Vio",
      created: "Creó",
      updated: "Actualizó",
      deleted: "Eliminó",
      submitted: "Entregó",
      reviewed: "Revisó",
      attempted: "Intentó",
      started: "Inició",
      loggedin: "Inició sesión",
      loggedout: "Cerró sesión",
      enrolled: "Matriculó",
      unenrolled: "Desmatriculó"
    };

    return acciones[accion] || accion;
  };
  const traducirEvento = (evento) => {

    const eventos = {
      "\\core\\event\\course_viewed": "Ingresó al curso",
      "\\core\\event\\course_module_viewed": "Abrió una actividad",
      "\\mod_quiz\\event\\course_module_viewed": "Abrió un cuestionario",
      "\\mod_resource\\event\\course_module_viewed": "Abrió un recurso",
      "\\core\\event\\course_module_created": "Creó una actividad",
      "\\core\\event\\course_module_updated": "Actualizó una actividad",
      "\\core\\event\\course_module_deleted": "Eliminó una actividad",
      "\\core\\event\\user_loggedin": "Inició sesión",
      "\\core\\event\\user_loggedout": "Cerró sesión",
      "\\core\\event\\calendar_event_created": "Creó un evento del calendario",
      "\\mod_quiz\\event\\attempt_started": "Inició un cuestionario",
      "\\mod_quiz\\event\\attempt_submitted": "Entregó un cuestionario",
      "\\mod_quiz\\event\\attempt_reviewed": "Revisó un cuestionario",
      "\\mod_quiz\\event\\report_viewed": "Consultó el informe del cuestionario",
      "\\mod_assign\\event\\submission_created": "Entregó una tarea",
      "\\mod_assign\\event\\submission_updated": "Actualizó una entrega",
      "\\mod_assign\\event\\submission_graded": "Recibió una calificación",
      "\\mod_forum\\event\\discussion_created": "Creó un debate en foro",
      "\\mod_forum\\event\\post_created": "Publicó en un foro",
      "\\mod_forum\\event\\post_updated": "Editó un mensaje del foro",
      "\\core\\event\\question_deleted": "Eliminó una pregunta",
      //"\\core\\event\\question_category_viewed": "Vio la categoría de preguntas",
      //"\\core\\event\\grade_deleted": "Eliminó una calificación" // 👈 NUEVO
    };
    return eventos[evento] || evento;
  };
  const buscarLogs = async () => {

    if (!dni) return;

    try {

      setLoading(true);

      let url = `https://wwwp.isepsantafe.net.ar/moodleservice/logs-usuario-escuela?dni=${dni}`;

      if (escuela) {
        url += `&escuela=${encodeURIComponent(escuela)}`;
      }

      const response = await axios.post(url);

      setLogs(response.data);

    } catch (error) {

      console.error(error);
      alert("Error consultando los logs");

    } finally {

      setLoading(false);

    }

  };

  return (
    <div style={{ padding: "20px" }}>

      <h2>Logs de Usuario Moodle</h2>

      <div style={{ marginBottom: "20px" }}>

        <input
          type="text"
          placeholder="Ingrese DNI"
          value={dni}
          onChange={(e) => setDni(e.target.value)}
          style={{
            padding: "8px",
            marginRight: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc"
          }}
        />

        <button
          onClick={buscarLogs}
          style={{
            padding: "8px 15px",
            backgroundColor: "#3659a1",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer"
          }}
        >
          Buscar
        </button>

      </div>

      {loading && <p>Consultando logs...</p>}

      <div
        style={{
          width: "100%",
          padding: "0 10px"
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            tableLayout: "auto"
          }}
        >
          <thead>
            <tr style={{ background: "#3659a1", color: "white" }}>
              <th style={{ ...th, width: "30%" }}>Curso</th>
              <th style={{ ...th, width: "20%" }}>Cuestionario</th>
              <th style={{ ...th, width: "25%" }}>Evento</th>
              {/*<th style={{ ...th, width: "8%" }}>Acción</th>*/}
              <th style={{ ...th, width: "10%" }}>Fecha</th>
              <th style={{ ...th, width: "7%" }}>IP</th>
            </tr>
          </thead>

          <tbody>
            {logs.map((log, index) => (
              <tr key={index}>
                <td style={td}>{log.curso}</td>
                <td style={td}>{log.cuestionario || "-"}</td>
                <td style={td}>{traducirEvento(log.evento)}</td>
                {/*<td style={td}>{traducirAccion(log.accion)}</td>*/}
                <td style={{ ...td, whiteSpace: "nowrap" }}>
                  {log.fecha}
                </td>
                <td style={{ ...td, whiteSpace: "nowrap" }}>
                  {log.ip || "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
};

const th = {
  padding: "10px",
  border: "1px solid #ddd",
  textAlign: "left"
};

const td = {
  padding: "8px",
  border: "1px solid #ddd"
};

export default LogsUsuarioMiIsep;